import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';

class housekeepingLinenChangeStore {

    // Properties

    @observable housekeepingLinenChange = undefined;
    @observable housekeepingLinenChangeLoading = false;

    // Initialization

    @action initHousekeepingLinenChange() {
        this.housekeepingLinenChangeLoading = true;
        const roomNo = JSON.parse(window.localStorage.getItem('roomNo'));
        const customerId = window.localStorage.getItem('customerId');

        return ApiCaller.HousekeepingLinenChanges.apiGetHousekeepingLinenChangeByRoomNumberAndGuestId(roomNo, parseInt(customerId)).then((housekeepingLinenChangeResponse) => {
            if (housekeepingLinenChangeResponse) {
                this.housekeepingLinenChange = housekeepingLinenChangeResponse;
            } else {
                this.housekeepingLinenChange = undefined;
            }

            this.housekeepingLinenChangeLoading = false;
        })
    }

    // Update

    @action updateHousekeepingLinenChange() {
        this.housekeepingLinenChangeLoading = true;
        return ApiCaller.HousekeepingLinenChanges.apiUpdateHousekeepingLinenChange(this.housekeepingLinenChange.housekeepingLinenChangeId, this.housekeepingLinenChange).then((housekeepingLinenChangeResponse) => {
            this.initHousekeepingLinenChange();
        })
    }

    // Set Properties

    @action setHousekeepingLinenChangeIsSunday(value) {
        this.housekeepingLinenChange.isSunday = value;
    }

    @action setHousekeepingLinenChangeIsMonday(value) {
        this.housekeepingLinenChange.isMonday = value;
    }

    @action setHousekeepingLinenChangeIsTuesday(value) {
        this.housekeepingLinenChange.isTuesday = value;
    }

    @action setHousekeepingLinenChangeIsWednesday(value) {
        this.housekeepingLinenChange.isWednesday = value;
    }

    @action setHousekeepingLinenChangeIsThursday(value) {
        this.housekeepingLinenChange.isThursday = value;
    }

    @action setHousekeepingLinenChangeIsFriday(value) {
        this.housekeepingLinenChange.isFriday = value;
    }

    @action setHousekeepingLinenChangeIsSaturday(value) {
        this.housekeepingLinenChange.isSaturday = value;
    }
}

export default new housekeepingLinenChangeStore()